import { Link } from "react-router-dom";
import { MapPin, ShieldCheck, Weight, Gavel } from "lucide-react";
import { Countdown } from "@/components/Countdown";
import { MODE_MAP } from "@/lib/data";
import { clp, lotImage, num } from "@/lib/api";

const Price = ({ lot }) => {
  if (lot.mode === "donacion") return <span className="text-indigo-700">Gratis por Retiro</span>;
  if (lot.mode === "venta") return <span>{clp(lot.price)}</span>;
  return (
    <span className="flex items-center gap-1.5"><Gavel className="w-4 h-4 text-amber-600" />{clp(lot.current_bid || lot.starting_bid)}</span>
  );
};

export const LotCard = ({ lot, index = 0 }) => {
  const mode = MODE_MAP[lot.mode];
  return (
    <Link to={`/lotes/${lot.id}`} data-testid={`lot-card-${lot.id}`} style={{ animationDelay: `${index * 60}ms` }}
      className="rise group bg-white border border-slate-200/80 rounded-2xl overflow-hidden flex flex-col shadow-sm hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300">
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
        <img src={lotImage(lot)} alt={lot.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <span className="absolute top-3 left-3 text-[11px] font-semibold uppercase tracking-wide px-2.5 py-1 rounded-full bg-[#0a1f18]/85 text-[#00f2a1] backdrop-blur" data-testid="lot-card-material-tag">{lot.material_tag}</span>
        {lot.verified && (
          <span className="absolute top-3 right-3 flex items-center gap-1 text-[11px] font-semibold px-2 py-1 rounded-full bg-[#00f2a1] text-[#05130e]" data-testid="lot-card-verified-badge">
            <ShieldCheck className="w-3.5 h-3.5" /> Pureza verificada
          </span>
        )}
        {lot.mode === "subasta" && (
          <span className="absolute bottom-3 left-3 flex items-center gap-2 text-xs px-2.5 py-1 rounded-full bg-black/70 text-white">
            <span className="live-dot w-2 h-2 rounded-full bg-red-500" /><Countdown endsAt={lot.auction_ends_at} testId="lot-card-countdown" />
          </span>
        )}
      </div>
      <div className="p-5 flex flex-col gap-3 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className={`text-[11px] font-semibold uppercase tracking-wide px-2.5 py-0.5 rounded-full border ${mode.cls}`} data-testid="lot-card-mode">{mode.label}</span>
          {lot.ler_code && <span className={`font-mono text-[11px] px-2 py-0.5 rounded-full border ${lot.hazardous ? "border-red-200 bg-red-50 text-red-700" : "border-slate-200 text-slate-600"}`} data-testid="lot-card-ler">LER {lot.ler_code}</span>}
        </div>
        <h3 className="font-semibold text-[15px] leading-snug text-[#05130e] line-clamp-2">{lot.title}</h3>
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-[13px] text-slate-600">
          <span className="flex items-center gap-1" data-testid="lot-card-weight"><Weight className="w-3.5 h-3.5" />{num(lot.weight_tons, 2)} Toneladas</span>
          <span className="flex items-center gap-1" data-testid="lot-card-location"><MapPin className="w-3.5 h-3.5" />{lot.comuna}, {lot.region.replace("Región de ", "").replace("Región del ", "")}</span>
        </div>
        <div className="mt-auto pt-3 border-t border-slate-100 flex items-center justify-between font-display font-bold text-lg text-[#05130e]" data-testid="lot-card-price">
          <Price lot={lot} />
          <span className="text-xs font-sans font-medium text-slate-400 group-hover:text-[#00b37a] transition-colors">Ver lote →</span>
        </div>
      </div>
    </Link>
  );
};
